@if (isShow) {
<div class="progress-bar-wrap text-center">
    <p class="fa-times-wrap"><i class="fa fa-times" (click)="stopProcess()"></i></p>
    <div class="app-progress-bar">
        <div class="text-center loading">
            <h5>Loading {{ value }}%</h5>
        </div>
        <progressbar [animate]="true" [value]="value" max="100" type="success"></progressbar>
    </div>
</div>
}
